module.exports = __webpack_public_path__ + "92bf2504edd43ee433fd32018f971af2.png";